import { useLanguage, t } from "../../../i18n";
import React from "react";
import { Card } from "react-bootstrap";
import "./HowItWorksCard.css";
export default function HowItWorksCard({
  icon,
  step,
  title,
  description
}) {
  useLanguage();
  const Icon = icon;
  return <Card className="bb-how-card h-100">
      <Card.Body>
        <div className="bb-how-card__step">{t(step)}</div>

        <div className="bb-how-card__icon bb-icon">
          <Icon />
        </div>

        <div className="bb-how-card__title">{t(title)}</div>
        <p className="bb-how-card__description">{t(description)}</p>
      </Card.Body>
    </Card>;
}
